import ArticleRoundedIcon from '@mui/icons-material/ArticleRounded';
import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded';
import DescriptionRoundedIcon from '@mui/icons-material/DescriptionRounded';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import LightbulbRoundedIcon from '@mui/icons-material/LightbulbRounded';
import CampaignRoundedIcon from '@mui/icons-material/CampaignRounded';
import EventRoundedIcon from '@mui/icons-material/EventRounded';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import WorkRoundedIcon from '@mui/icons-material/WorkRounded';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';
import HealthAndSafetyRoundedIcon from '@mui/icons-material/HealthAndSafetyRounded';
import GavelRoundedIcon from '@mui/icons-material/GavelRounded';
import SecurityRoundedIcon from '@mui/icons-material/SecurityRounded';
import PaymentsRoundedIcon from '@mui/icons-material/PaymentsRounded';
import BeachAccessRoundedIcon from '@mui/icons-material/BeachAccessRounded';
import RestaurantRoundedIcon from '@mui/icons-material/RestaurantRounded';
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded';
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import ChecklistRoundedIcon from '@mui/icons-material/ChecklistRounded';
import AssignmentRoundedIcon from '@mui/icons-material/AssignmentRounded';
import FolderRoundedIcon from '@mui/icons-material/FolderRounded';
import LinkRoundedIcon from '@mui/icons-material/LinkRounded';
import LaptopRoundedIcon from '@mui/icons-material/LaptopRounded';
import PhoneRoundedIcon from '@mui/icons-material/PhoneRounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import CelebrationRoundedIcon from '@mui/icons-material/CelebrationRounded';
import EmojiEventsRoundedIcon from '@mui/icons-material/EmojiEventsRounded';
import FlightRoundedIcon from '@mui/icons-material/FlightRounded';
import DirectionsCarRoundedIcon from '@mui/icons-material/DirectionsCarRounded';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import BadgeRoundedIcon from '@mui/icons-material/BadgeRounded';
import HandshakeRoundedIcon from '@mui/icons-material/HandshakeRounded';
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import PsychologyRoundedIcon from '@mui/icons-material/PsychologyRounded';
import SavingsRoundedIcon from '@mui/icons-material/SavingsRounded';
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
import WifiRoundedIcon from '@mui/icons-material/WifiRounded';
import BuildRoundedIcon from '@mui/icons-material/BuildRounded';
import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';
import LocalHospitalRoundedIcon from '@mui/icons-material/LocalHospitalRounded';
import MedicationRoundedIcon from '@mui/icons-material/MedicationRounded';
import FitnessCenterRoundedIcon from '@mui/icons-material/FitnessCenterRounded';
import SelfImprovementRoundedIcon from '@mui/icons-material/SelfImprovementRounded';
import ChildCareRoundedIcon from '@mui/icons-material/ChildCareRounded';
import PetsRoundedIcon from '@mui/icons-material/PetsRounded';
import LocalCafeRoundedIcon from '@mui/icons-material/LocalCafeRounded';
import LocalParkingRoundedIcon from '@mui/icons-material/LocalParkingRounded';
import DirectionsBusRoundedIcon from '@mui/icons-material/DirectionsBusRounded';
import DirectionsBikeRoundedIcon from '@mui/icons-material/DirectionsBikeRounded';
import ApartmentRoundedIcon from '@mui/icons-material/ApartmentRounded';
import MeetingRoomRoundedIcon from '@mui/icons-material/MeetingRoomRounded';
import MapRoundedIcon from '@mui/icons-material/MapRounded';
import LanguageRoundedIcon from '@mui/icons-material/LanguageRounded';
import ForumRoundedIcon from '@mui/icons-material/ForumRounded';
import FeedbackRoundedIcon from '@mui/icons-material/FeedbackRounded';
import QuizRoundedIcon from '@mui/icons-material/QuizRounded';
import VideoLibraryRoundedIcon from '@mui/icons-material/VideoLibraryRounded';
import Inventory2RoundedIcon from '@mui/icons-material/Inventory2Rounded';
import EngineeringRoundedIcon from '@mui/icons-material/EngineeringRounded';
import ScienceRoundedIcon from '@mui/icons-material/ScienceRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import FactoryRoundedIcon from '@mui/icons-material/FactoryRounded';
import AgricultureRoundedIcon from '@mui/icons-material/AgricultureRounded';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import StorefrontRoundedIcon from '@mui/icons-material/StorefrontRounded';
import PointOfSaleRoundedIcon from '@mui/icons-material/PointOfSaleRounded';
import EnergySavingsLeafRoundedIcon from '@mui/icons-material/EnergySavingsLeafRounded';
import RecyclingRoundedIcon from '@mui/icons-material/RecyclingRounded';
import VolunteerActivismRoundedIcon from '@mui/icons-material/VolunteerActivismRounded';
import Diversity3RoundedIcon from '@mui/icons-material/Diversity3Rounded';
import AccessibleRoundedIcon from '@mui/icons-material/AccessibleRounded';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import LocalFireDepartmentRoundedIcon from '@mui/icons-material/LocalFireDepartmentRounded';
import KeyRoundedIcon from '@mui/icons-material/KeyRounded';
import PrintRoundedIcon from '@mui/icons-material/PrintRounded';
import CakeRoundedIcon from '@mui/icons-material/CakeRounded';
import ParkRoundedIcon from '@mui/icons-material/ParkRounded';
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import LoyaltyRoundedIcon from '@mui/icons-material/LoyaltyRounded';
import DiscountRoundedIcon from '@mui/icons-material/DiscountRounded';
import LocalFloristRoundedIcon from '@mui/icons-material/LocalFloristRounded';
import FilterVintageRoundedIcon from '@mui/icons-material/FilterVintageRounded';

export const icons = [
  { key: 'page', Icon: ArticleRoundedIcon },
  { key: 'guide', Icon: MenuBookRoundedIcon },
  { key: 'document', Icon: DescriptionRoundedIcon },
  { key: 'faq', Icon: HelpOutlineRoundedIcon },
  { key: 'info', Icon: InfoRoundedIcon },
  { key: 'tips', Icon: LightbulbRoundedIcon },
  { key: 'news', Icon: CampaignRoundedIcon },
  { key: 'calendar', Icon: EventRoundedIcon },
  { key: 'time', Icon: ScheduleRoundedIcon },
  { key: 'team', Icon: GroupsRoundedIcon },
  { key: 'work', Icon: WorkRoundedIcon },
  { key: 'training', Icon: SchoolRoundedIcon },
  { key: 'health', Icon: HealthAndSafetyRoundedIcon },
  { key: 'policy', Icon: GavelRoundedIcon },
  { key: 'security', Icon: SecurityRoundedIcon },
  { key: 'pay', Icon: PaymentsRoundedIcon },
  { key: 'leave', Icon: BeachAccessRoundedIcon },
  { key: 'food', Icon: RestaurantRoundedIcon },
  { key: 'location', Icon: LocationOnRoundedIcon },
  { key: 'contact', Icon: SupportAgentRoundedIcon },
  { key: 'checklist', Icon: ChecklistRoundedIcon },
  { key: 'tasks', Icon: AssignmentRoundedIcon },
  { key: 'folder', Icon: FolderRoundedIcon },
  { key: 'links', Icon: LinkRoundedIcon },
  { key: 'it', Icon: LaptopRoundedIcon },
  { key: 'phone', Icon: PhoneRoundedIcon },
  { key: 'email', Icon: EmailRoundedIcon },
  { key: 'celebration', Icon: CelebrationRoundedIcon },
  { key: 'awards', Icon: EmojiEventsRoundedIcon },
  { key: 'travel', Icon: FlightRoundedIcon },
  { key: 'car', Icon: DirectionsCarRoundedIcon },
  { key: 'remote', Icon: HomeRoundedIcon },
  { key: 'id_badge', Icon: BadgeRoundedIcon },
  { key: 'welcome', Icon: HandshakeRoundedIcon },
  { key: 'values', Icon: FavoriteRoundedIcon },
  { key: 'mental_health', Icon: PsychologyRoundedIcon },
  { key: 'savings', Icon: SavingsRoundedIcon },
  { key: 'expenses', Icon: ReceiptRoundedIcon },
  { key: 'wifi', Icon: WifiRoundedIcon },
  { key: 'facilities', Icon: BuildRoundedIcon },
  { key: 'bank', Icon: AccountBalanceRoundedIcon },
  { key: 'medical', Icon: LocalHospitalRoundedIcon },
  { key: 'medicine', Icon: MedicationRoundedIcon },
  { key: 'sports', Icon: FitnessCenterRoundedIcon },
  { key: 'wellbeing', Icon: SelfImprovementRoundedIcon },
  { key: 'family', Icon: ChildCareRoundedIcon },
  { key: 'pets', Icon: PetsRoundedIcon },
  { key: 'coffee', Icon: LocalCafeRoundedIcon },
  { key: 'parking', Icon: LocalParkingRoundedIcon },
  { key: 'commute', Icon: DirectionsBusRoundedIcon },
  { key: 'bike', Icon: DirectionsBikeRoundedIcon },
  { key: 'building', Icon: ApartmentRoundedIcon },
  { key: 'rooms', Icon: MeetingRoomRoundedIcon },
  { key: 'map', Icon: MapRoundedIcon },
  { key: 'languages', Icon: LanguageRoundedIcon },
  { key: 'discussion', Icon: ForumRoundedIcon },
  { key: 'feedback', Icon: FeedbackRoundedIcon },
  { key: 'quiz', Icon: QuizRoundedIcon },
  { key: 'videos', Icon: VideoLibraryRoundedIcon },
  { key: 'supplies', Icon: Inventory2RoundedIcon },
  { key: 'engineering', Icon: EngineeringRoundedIcon },
  { key: 'science', Icon: ScienceRoundedIcon },
  { key: 'construction', Icon: ConstructionRoundedIcon },
  { key: 'factory', Icon: FactoryRoundedIcon },
  { key: 'agriculture', Icon: AgricultureRoundedIcon },
  { key: 'logistics', Icon: LocalShippingRoundedIcon },
  { key: 'store', Icon: StorefrontRoundedIcon },
  { key: 'checkout', Icon: PointOfSaleRoundedIcon },
  { key: 'sustainability', Icon: EnergySavingsLeafRoundedIcon },
  { key: 'recycling', Icon: RecyclingRoundedIcon },
  { key: 'charity', Icon: VolunteerActivismRoundedIcon },
  { key: 'diversity', Icon: Diversity3RoundedIcon },
  { key: 'accessibility', Icon: AccessibleRoundedIcon },
  { key: 'warning', Icon: WarningRoundedIcon },
  { key: 'fire_safety', Icon: LocalFireDepartmentRoundedIcon },
  { key: 'keys', Icon: KeyRoundedIcon },
  { key: 'printing', Icon: PrintRoundedIcon },
  { key: 'birthdays', Icon: CakeRoundedIcon },
  { key: 'outdoors', Icon: ParkRoundedIcon },
  { key: 'featured', Icon: StarRoundedIcon },
  { key: 'loyalty', Icon: LoyaltyRoundedIcon },
  { key: 'discounts', Icon: DiscountRoundedIcon },
  { key: 'flowers', Icon: LocalFloristRoundedIcon },
  { key: 'blossom', Icon: FilterVintageRoundedIcon },
];

const iconsByKey = Object.fromEntries(icons.map(({ key, Icon }) => [key, Icon]));

export const getIcon = (key, FallbackIcon = null) => iconsByKey[key] ?? FallbackIcon;
